import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GridFilterSelectMultiple } from './GridFilterSelectMultiple';
import { UserState } from '@api/models/enums/UserState';

// Internal users are never REQUESTED - that state only exists for supplier employees
// (see GridFilterSupplierEmployeeState).
const options = Object.values(UserState).filter((state) => state !== UserState.Requested);

interface Props {
  value?: UserState[];
  onChange: (value?: UserState) => void;
}

export const GridFilterUserState: FC<Props> = ({ value, onChange }) => {
  const { t } = useTranslation();

  if (!value) {
    return null;
  }

  return (
    <GridFilterSelectMultiple
      value={value}
      options={options}
      onChange={onChange}
      getOptionId={(option: UserState) => option}
      getOptionName={(option: UserState) => t(`entityState.${option}`)}
    />
  );
};
